import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setDeviceDimension } from "store/slices/device/slice";

const useDeviceDimension = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const setRealDeviceHeight = () => {
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;
      document.documentElement.style.setProperty(
        "--device-view-height",
        `${viewportHeight}px`,
      );
      dispatch(
        setDeviceDimension({ height: viewportHeight, width: viewportWidth }),
      );
    };
    setRealDeviceHeight();
    window.addEventListener("resize", setRealDeviceHeight);
    return () => {
      window.removeEventListener("resize", setRealDeviceHeight);
    };
  }, [dispatch]);
};

export default useDeviceDimension;
